module.exports = __webpack_public_path__ + "static/img/bg.e3c2290.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/bg.jpg
// module id = dInV
// module chunks = 7